import React, { useEffect, useRef, useState } from 'react';
import StoryArtwork from '../StoryArtwork/StoryArtwork';
import './StoryWorlds.css';

interface Props {
  src?: string | null;
  srcSet?: string | null;
  motion?: boolean;
  eager?: boolean;
}

/** Only visible, foreground scenes animate. Artwork remains usable without motion. */
const StoryBackdrop: React.FC<Props> = ({ src, srcSet, motion = true, eager = false }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const [foreground, setForeground] = useState(document.visibilityState !== 'hidden');
  const [reduced, setReduced] = useState(true);
  useEffect(() => {
    const media = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    const update = () => setReduced(media?.matches ?? true);
    const onVisibility = () => setForeground(document.visibilityState !== 'hidden');
    update();
    media?.addEventListener?.('change', update);
    document.addEventListener('visibilitychange', onVisibility);
    const observer = typeof IntersectionObserver === 'undefined' ? null : new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting), { threshold: .05 });
    if (ref.current) observer?.observe(ref.current);
    return () => {
      observer?.disconnect();
      media?.removeEventListener?.('change', update);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);
  const animate = motion && visible && foreground && !reduced;
  return <div ref={ref} className={'story-backdrop' + (animate ? ' story-backdrop--moving' : '')} aria-hidden="true">
    <StoryArtwork src={src} srcSet={srcSet} sizes="100vw" imageClassName="story-backdrop__image" fallbackClassName="story-backdrop__fallback" fallbackSize={80} loading={eager ? 'eager' : 'lazy'} />
    <div className="story-backdrop__shade" />
    <div className="story-backdrop__lights">{Array.from({ length: 8 }, (_, index) => <span key={index} style={{ left: (12 + index * 11) + '%', top: (20 + (index * 13) % 44) + '%', animationDelay: (-index * 1.8) + 's' }} />)}</div>
  </div>;
};
export default StoryBackdrop;
